<template>
        <v-container>
            <v-row class="mb-lg-12 mt-4 pt-4" justify="center">
                <v-col cols="12" class="text-center">
                    <div class="text-h4 text-md-h3 text">{{curso.nome}}</div>
                    <div class=" my-6 text-h4 text-md-h3 text"> com </div>
                    <div class="text-h4 text-md-h3 text">{{curso.instrutor}}</div>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-lg-12">
                <v-col cols="6" class="text-center">
                    <v-card color="transparent" flat>
                        <v-card-text>
                            <div class="text-subtitle-1 text-md-h4">{{curso.descricao}}</div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row class="my-lg-12" justify="center">
                <v-col cols="6" class="text-center">
                    <div class="text-h5">Aulas : {{curso.total_aulas}}</div>
                    <div class="text-h5">Concluídas : {{curso.aulas_completas}}</div>
                </v-col>
            </v-row>
            <v-row class="d-lg-none" justify="center">
                <v-col class="text-center">
                    <v-btn @click="acessarConteudo()" color="primary">Acessar Conteudo</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-12">
                <v-col cols="12" class="col-sm-6 text-center">
                    <div class="mb-2 text-h5">{{progresso}}%</div>
                    <v-progress-linear height="18" :value="progresso"></v-progress-linear>
                </v-col>
            </v-row>
        </v-container>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import { baseApiUrl, showError } from "@/config/global"

export default {
    props:['curso'],
    computed:{
        ...mapState(['user']),
        progresso(){
            return Math.round((this.curso.aulas_completas * 100) / this.curso.total_aulas)
        }
    },
    methods:{
        acessarConteudo(){
            const url = `${baseApiUrl}/estudos/Cursos/buscarProximaAula.php?iniciado=${this.user.user}&curso=${this.curso.id}`;
            let registro;

            axios.get(url).then(res=>{
                if(res.data.codigo == "01"){
                    registro = res.data.dados.map(a => {
                        return {
                            data_criacao: a.data_criacao,
                            id: a.id,
                            id_modulo: a.id_modulo,
                            nome: a.nome,
                            tipo: a.tipo,
                            url_video: a.url_video
                        }
                    })
                    registro = registro[0]
                    this.$emit('acessarConteudo', registro)
                }else{
                    showError("Erro ao resgatar conteudo")
                }
            })
        }
    }
}
</script>

<style scoped>
    .tela{
        background-color: rgba(220, 220, 255, 0.8);
        /* height: calc(100vh - 84px); */
        height: 100%;
        border-radius: 6px;
    }

@media only screen and (max-width: 600px){
    .tela{
        height: 100%;
        background-color: rgba(220, 220, 255, 0.8);
        border-radius: 6px;
    }
}
</style>